<template>
    <div class="panel-content">
        <div class="panel-content-head">
            <div class="panel-content-head-title">
                {{ pageData.title }}
            </div>
            <div class="panel-content-head-subTitle">
                {{ pageData.subTitle }}
            </div>
        </div>
        <div
            v-if="!data.length"
            class="panel-content-body"
        >
            <!-- {{pageData.content.left}}
            {{pageData.content.right}} -->
            <div class="panel-content-body-heard">
                <div class="panel-content-body-heard-title left">
                    修改前
                </div>
                <div class="panel-content-body-heard-title right">
                    修改后
                </div>
            </div>
            <div
                v-if="left.length"
                class="panel-content-body-count"
            >
                <!-- 需要比较两个数组的长度  -->
                <div
                    v-for="(item, index) in left"
                    :key="index"
                    class="panel-content-body-count-box"
                >
                    <div class="panel-content-body-count-box-item left">
                        <p class="panel-content-body-text">
                            {{ item.label }}
                        </p>
                        <template v-if="item.direction">
                            <a :href="item.direction">{{ item.text }}</a>
                            <template v-if="item.subText">
                                <span>{{ ';&nbsp;' + item.subText }}</span>
                            </template>
                        </template>
                        <template v-else>
                            <p class="panel-content-body-detail">
                                {{ item.text }}
                            </p>
                        </template>
                    </div>
                    <div class="panel-content-body-count-box-item right">
                        <p class="panel-content-body-text">
                            {{ right[index].label }}
                        </p>
                        <template v-if="right[index].direction">
                            <a :href="right[index].direction">{{ right[index].text }}</a>
                            <template v-if="right[index].subText">
                                <span>{{ ';&nbsp;' + right[index].subText }}</span>
                            </template>
                        </template>
                        <template v-else>
                            <p class="panel-content-body-detail">
                                {{ right[index].text }}
                            </p>
                        </template>
                    </div>
                </div>
            </div>
            <div class="line" />
        </div>
        <div
            v-if="data.length"
            class="panel-content-body"
        >
            <div class="panel-content-body-count">
                <div
                    v-for="(item, index) in data"
                    :key="index"
                    class="panel-content-body-count-box"
                >
                    <div class="panel-content-body-count-box-item left">
                        <p class="panel-content-body-text">
                            {{ item.label }}
                        </p>
                        <p class="panel-content-body-detail">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: {
    pageData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      data: [],
      left: [],
      right: [],
    };
  },
  watch: {
    pageData(newvalue) {
      // 判断pageData中是否含有data字段
      // this.checkLength();
      this.modifyData(newvalue);
      // console.log(newvalue, 'newvalue');
    },
  },
  mounted() {
    // this.checkLength();
    this.modifyData(this.pageData);
  },
  methods: {
    addLength(arra, arrb) {
      // 深拷贝一下
      const Arra = cloneDeep(arra);
      const Arrb = cloneDeep(arrb);
      let frequency = 0;
      let resultArr = [];
      if (arra.length > arrb.length) {
        frequency = arra.length - arrb.length;
        resultArr = Arrb;
      } else if (arra.length < arrb.length) {
        frequency = arrb.length - arra.length;
        resultArr = Arra;
      }
      for (let i = 0; i < frequency; i++) {
        resultArr.push({
          label: '',
          text: '',
        });
      }
      return {
        left: Arra,
        right: Arrb,
      };
    },
    // 判断content中是否存在data属性，确定走哪个渲染逻辑
    modifyData(pageData) {
      const { data } = (pageData && pageData.content) || {};

      this.data = [];
      this.left = [];
      this.right = [];

      if (data) {
        this.data = data;
      } else {
        this.checkLength();
      }
    },
    // 格式化数组 使left与right的长度相等
    checkLength() {
      const { left, right } = this.pageData.content;
      const resultObj = this.addLength(left, right);
      this.right = resultObj.right;
      this.left = resultObj.left;
    },
  },
};
</script>
<style lang="less">
.panel-content {
    height: 100%;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;

    &-head {
        // background: red;

        padding: 40px 0 20px 24px;

        box-shadow: 0 1px 0 0 #ebedf2;
        flex: 0 0 auto;

        &-title {
            font-weight: bold;
            font-size: 24px;
            color: #1e2330;
            line-height: 26px;
        }
        &-subTitle {
            margin-top: 8px;

            font-size: 14px;
            line-height: 20px;
            color: #a8abb3;
        }
    }

    &-body {
        position: relative;

        overflow-y: scroll;

        padding-top: 19px;

        &-heard {
            display: flex;
            // justify-content: space-between;

            width: 100%;

            .left {
                padding-left: 30px;
            }
            .right {
                padding-left: 40px;
            }

            &-title {
                width: 403px;
                margin-bottom: 7px;

                font-size: 14px;
                line-height: 14px;
                font-weight: bold;
                box-sizing: border-box;
            }
        }

        &-count {
            &-box {
                display: flex;
                padding: 19px 0;

                &-item {
                    width: 403px;
                    word-wrap: break-word;
                }
            }

            &-box:hover {
                background: rgba(111, 123, 150, 0.1);
            }

            .left {
                padding-left: 30px;
                box-sizing: border-box;
            }
            .right {
                padding-right: 30px;
                box-sizing: border-box;
                padding-left: 40px;
            }
        }

        .line {
            position: absolute;
            right: 50%;
            left: 50%;
            top: 0;

            height: 100%;
            width: 1px;
            background: #ebedf2;
        }
    }
}
</style>
